import { useBillingStatus } from '@/hooks/use-billing-status';
import { useGetCouponBanner } from '@/hooks/use-coupon-banner';
import { useTenant } from '@/hooks/use-tenant';
import { useGetWelcomeNotification } from '@/hooks/use-welcome-notification';
import {
  getCouponFeatureState,
  getWelcomeFeatureState,
} from '@/lib/app-editor/app-hub';
import { getNextSteps } from '@/lib/home-next-steps';

/**
 * "Próximos passos" of the Início (HOME-07) from the tenant, the billing
 * status and the welcome/coupon configs (same states as the App hub).
 * `isLoading` while any of them is still loading, so neither a false
 * pending item nor a false "Tudo em dia" shows.
 */
export function useNextSteps() {
  const tenant = useTenant();
  const billing = useBillingStatus();
  const welcome = useGetWelcomeNotification();
  const coupon = useGetCouponBanner();

  const steps = getNextSteps({
    tenant,
    billingState: billing.data?.state,
    welcome: getWelcomeFeatureState({
      status: welcome.status,
      data: welcome.data,
    }),
    coupon: getCouponFeatureState({
      status: coupon.status,
      data: coupon.data,
      appVersion: tenant.appVersion,
    }),
  });

  return {
    ...steps,
    isLoading: billing.isPending || welcome.isPending || coupon.isPending,
  };
}
